__turbopack_context__.v({
  "canvas": "Wgf-UG_canvas",
  "frame": "Wgf-UG_frame",
});
